// @ts-nocheck
/*
 * Session summary strip — agent avatar + name/number/started-at line +
 * metric group (Duration always; Viewport only when device info known).
 * Themed to match the app-wide summary-strip vocabulary.
 */
import React from 'react';
import moment from 'moment';
import { formatDuration } from '../replayUtils';

function initials(name: any) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return 'AG';
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
}

function Metric({ label, value }: any) {
  return (
    <div className="flex min-w-[96px] flex-col gap-0.5">
      <span className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <span className="text-base font-semibold tabular-nums text-foreground">
        {value}
      </span>
    </div>
  );
}

export default function SessionSummaryHeader({ session }: any) {
  if (!session) return null;
  const agent = session.agent || {};
  const name = agent.agent_name || `Agent #${session.agent_id}`;

  const metrics: any[] = [['Duration', formatDuration(session.duration_seconds)]];
  if (session.device?.viewport_w) {
    metrics.push([
      'Viewport',
      `${session.device.viewport_w}×${session.device.viewport_h}`,
    ]);
  }

  return (
    <div
      className="mb-3 flex flex-wrap items-center gap-6 rounded-xl border border-border/60 bg-muted/40 px-5 py-3.5"
    >
      {/* Identity block */}
      <div className="flex min-w-0 items-center gap-3">
        <div
          aria-hidden="true"
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold tracking-wide text-primary ring-1 ring-inset ring-primary/25"
        >
          {initials(agent.agent_name)}
        </div>
        <div className="min-w-0">
          <div className="truncate text-base font-bold leading-tight text-foreground">
            {name}
          </div>
          <div className="text-xs tabular-nums text-muted-foreground">
            {agent.agent_number ? `${agent.agent_number} · ` : ''}
            {session.started_at
              ? moment(session.started_at).format('DD MMM YYYY, HH:mm')
              : ''}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div
        aria-hidden="true"
        className="hidden h-8 w-px self-center bg-border/60 md:block"
      />

      {/* Metric group */}
      <div className="flex flex-wrap items-center gap-6">
        {metrics.map(([label, value]: any) => (
          <Metric key={label} label={label} value={value} />
        ))}
      </div>
    </div>
  );
}
